import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { envioCorreoCotizacion, cerrarModal } from './reducer/todo-reducer';


class ModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            muestra: false,
            mensaje: {},
            correo: "",
            enviado: false
        };

    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.mostrar) {
            this.setState({ muestra: nextprops.mostrar });
        }

        if (nextprops.correoEnviado) {
            this.setState({ enviado: true });
        } else if (nextprops.correoEnviado === null) {
            this.setState({ enviado: false, correo: "" });

        }

        if (nextprops.cierraModal === false) {
            this.setState({ muestra: nextprops.cierraModal });
        }
    }

    componentDidMount() {
        console.log(this.props);
    }

    render() {

        if (!this.state.muestra) {
            return null
        } else {
            return (
                <div>
                    <div className="modal fade in" tabIndex="-1" style={{ display: "block" }} role="dialog" >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal.bind(this)}>
                                        <span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        {this.state.enviado === false ? (<div>
                                            <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                                                <label>Ingresa tu correo electrónico y te enviaremos tu cotización.</label>
                                            </div>
                                            <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                                                <div className="form-group">
                                                    <label htmlFor="correo">Correo electrónico <span className="requiredIn">*</span></label>
                                                    <input type="text" maxLength="60" className="form-control browser-default" id="correo" name="correo"
                                                        value={this.state.correo ? this.state.correo : ""}
                                                        onChange={this.changeValues.bind(this)} />
                                                    {
                                                        this.state.mensaje ?
                                                            this.state.mensaje.correo ? <p className="errorMsj">{this.state.mensaje.correo}</p> : null
                                                            : null
                                                    }

                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12 text-right">
                                                <button className="btn btn-gnp" onClick={this.enviarCorreo.bind(this)}>Aceptar</button>

                                            </div>
                                        </div>
                                        ) : <div>
                                                <div className="col-md-2 col-sm-2 col-xs-2 col-lg-2">
                                                    <div className="imageExitoCot" >
                                                    </div>

                                                </div>

                                                <div className="col-md-10 col-sm-10 col-xs-10 col-lg-10 text-justify">
                                                    <p>Se ha enviado la cotización a su correo electrónico.</p>
                                                </div>
                                            </div>
                                        }

                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="modal-backdrop fade in" ></div>
                </div>
            )
        }
    }

    changeValues(event) {
        var mensaje = this.state.mensaje;
        mensaje.correo = null;
        this.setState({ correo: event.target.value, mensaje });
    }

    enviarCorreo(event) {
        var mensaje = this.state.mensaje
        var valido = true;
        if (this.state.correo.trim() === "") {
            mensaje.correo = "Campo requerido.";
            valido = false;
        } else {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(this.state.correo)) {
                mensaje.correo = "Capture un correo válido.";
                valido = false;
            }
        }

        this.setState({ mensaje });

        if (valido) {

            var values = {
                cotizacion: this.props.cotizacion,
                correo: this.state.correo
            }
            this.props.actions.envioCorreoCotizacion(values);
        }
    }

    closeModal(event) {
        this.props.actions.cerrarModal();
    }
}

const mapStateToProps = (state) => {
    return {
        correoEnviado: state.educacionReducer.get("correoEnviado"),
        cierraModal: state.educacionReducer.get("cierraModal")
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ envioCorreoCotizacion: envioCorreoCotizacion, cerrarModal: cerrarModal }, dispatch)
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalComponent);


// WEBPACK FOOTER //
// ./src/ModalCorreo.js